import * as React from 'react';
import * as $ from 'jquery';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { StreetAddressViewModel } from '../StreetAddress';
import Invoice from './Invoice';
import LoadingPanel from '../LoadingPanel';
import LoadingButton from '../LoadingButton';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import InvoiceDropDown, { InvoiceSearchResult } from '../InvoiceDropDown';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { FacilitySearchResult } from '../FacilityComboBox';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    periods: BillingPeriodData[];
    invoices: InvoiceData[];
    errors: AlertData[];
    warnings: AlertData[];
    isGenerated: boolean;
    justImported: boolean;
    isLoading: boolean;
    currentPeriodId: number | null;
    apiInfo: APIInfo;

    facilities: FacilitySearchResult[];
    isSaving: boolean;
    validation: boolean;
    accountId: number;

    invoiceId: number;
    facilityID: undefined|number;
    source: undefined|number;
    amount: number | null;
    comment: string;
    date: Date | null;
    chargeDescription: string;
    publishableKey: string;
}

export interface InvoiceData {
    InvoiceId: number;
    AccountID: number;
    Number: number;
    BillDate: Date;
    BillingPeriodName: string;
    FacilityID: number;
    FacilityName: string;
    FacilityAddress: StreetAddressViewModel;
    BillToName: string;
    BillToAddress: StreetAddressViewModel;
    Tax: number;
    PreviousBalance: number;
    SubTotal: number;
    Total: number;
    TotalDue: number;
    Terms: string;
    Items: InvoiceItemData[];
    DisplayOutstanding: boolean;
    AltInvoiceNum: string;
}

export type APIInfo = {
    APIType: number;
    Name: string;
    Links: ApiLink[];
    ImageURL: string;
    PortalURL: string;
}

type BillingPeriodData = {
    BillingPeriodID: number;
    Name: string;
    StartDate: Date;
    EndDate: Date;
}

type InvoiceItemData = {
    Description: string;
    Quantity: number;
    UnitOfMeasure: string;
    Rate: number;
    Total: number;
}

type AlertData = {
    Message: string;
    Link: string;
}


class Invoices extends React.Component<Props, State> {
    paymentTypes = [
        { text: 'Cash', value: 0 },
        { text: 'Cheque', value: 1 },
        { text: 'e-Transfer', value: 2 },
        { text: 'Credit Card', value: 3 },
        { text: 'Discount', value: 5 }
    ];

    private myWindowTimer!: NodeJS.Timeout;
    private myWindow!: Window | null;

    constructor(props: Props) {
        super(props);

        this.state = {
            periods: [],
            invoices: [],
            errors: [],
            warnings: [],
            isGenerated: false,
            justImported: false,
            isLoading: false,
            currentPeriodId: null,
            apiInfo: null,
            facilities: [],
            facilityID: 0,
            amount: 0,
            comment: '',
            source: -1,
            date: new Date(),
            isSaving: false,
            validation: false,
            accountId: 0,
            invoiceId: 0,
            chargeDescription: '',
            publishableKey: ''
        };

        this.chargeCreditCard = this.chargeCreditCard.bind(this);
        this.handleFacilityChange = this.handleFacilityChange.bind(this);
        this.handleSourceChange = this.handleSourceChange.bind(this);
        this.save = this.save.bind(this);
        this.setPaymentData = this.setPaymentData.bind(this);
        this.requestFacilities = this.requestFacilities.bind(this);
        this.requestBillingPeriods = this.requestBillingPeriods.bind(this);
        this.requestInvoices = this.requestInvoices.bind(this);
        this.generate = this.generate.bind(this);
        this.importIntoQB = this.importIntoQB.bind(this);
        this.email = this.email.bind(this);
       // this.importIntoFB = this.importIntoFB.bind(this);
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Invoices" />
            <div className="form-row py-2 d-print-none">
                <div className="col-auto">
                    <label>Billing Period&nbsp;</label>
                    <DropDownList
                        data={this.state.periods}
                        textField="Name"
                        value={this.state.periods.find(x => x.BillingPeriodID == this.state.currentPeriodId)}
                        onChange={(e) => {
                            this.setState({ currentPeriodId: e.target.value.BillingPeriodID }, () => this.requestInvoices());
                        }}
                        style={{ width: '360px' }}
                    />
                </div>
                <div className="col-auto ml-auto">
                    <Link
                        role="button"
                        className="btn btn-secondary"
                        to={'/invoices/periods'}
                    >
                        Billing Periods
                    </Link>
                    &nbsp;
                    {this.state.currentPeriodId > 0 && <button role="button" className="btn btn-primary" onClick={() => { window.print() }}>Print Invoices</button>}
                    &nbsp;
                    {this.state.currentPeriodId > 0 && this.state.isGenerated && <button role="button" className="btn btn-primary" onClick={() => confirm("Invoices will be sent to accounts included in this batch.  Do you want to continue? ") && this.email()}>Email Invoices</button>}
                    &nbsp;
                    {this.state.invoices.length > 0 && this.state.errors.length === 0 && !this.state.isGenerated &&
                        <LoadingButton className="btn btn-success" onClick={() => confirm("Are you sure you want to finalize all invoices?") && this.generate()} isLoading={this.state.isLoading}>Finalize Invoices</LoadingButton>
                    }
                    {/*this.state.isGenerated && <button role="button" className="btn btn-success" id="btnValidateAccounts" onClick={(e) => { this.importIntoQB(e) }} title="Validate accounts prior to import">Validate Accounts</button>*/}
                    {this.state.isGenerated && this.state.apiInfo && <button role="button" className="btn btn-success" id="btnImportInvoices" onClick={() => { this.importIntoQB() }} title={"Import into " + this.state.apiInfo.Name}>Import Invoices</button>}
                </div>
            </div>
            {this.state.errors.map((error, index) => {
                return <div className="alert alert-danger d-print-none" key={index}>
                    {error.Message}&nbsp;
                    {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                </div>
            })}
            {this.state.warnings.map((warning, index) => {
                return <div className="alert alert-warning d-print-none" key={index}>
                    {warning.Message}&nbsp;
                    {warning.Link && <Link to={warning.Link} className="alert-link">Adjust Here</Link>}
                </div>
            })}
            {this.state.justImported && <div className="alert alert-success d-print-none">Import is complete.</div>}
            {!this.state.justImported && this.state.isGenerated && <div className="alert alert-success d-print-none">These invoices are finalized, and can't be changed.</div>}
            {this.state.invoices.map((invoice, index) => {
                return (<React.Fragment>
                            <button role="button" className="btn btn-primary float-right d-print-none" data-toggle="modal" data-target=".bd-example-modal-lg" onClick={() => { this.setPaymentData(invoice)}}>Add Payment</button>
                            <Invoice invoice={invoice} key={index} />
                            <hr />
                        </React.Fragment>);
            })}
            {!this.state.isLoading && this.state.invoices.length === 0 && <h4 className="text-center">No Invoices Found.</h4>}
            <div id="paymentModal" className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Payment</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                {this.state.facilities !== [] &&
                                    <DropDownList
                                        data={this.state.facilities}
                                        textField={'Name'}
                                        defaultItem={{ Name: 'Facility', ID: -1 }}
                                        value={this.state.facilities.find(x => x.FacilityId === this.state.facilityID)}
                                        onChange={this.handleFacilityChange}
                                    />
                                }
                                {this.state.validation && (this.state.facilityID === -1 || this.state.facilityID === undefined) && <p className="error-msg">Please select Facility</p>}
                            </div>
                            <div className="form-group">
                                <DropDownList
                                    data={this.paymentTypes}
                                    textField={'text'}
                                    defaultItem={{ text: 'Payment Type', value: -1 }}
                                    value={this.paymentTypes.find(x => x.value === this.state.source)}
                                    onChange={this.handleSourceChange}
                                />
                                {this.state.validation && (this.state.source === -1 || this.state.source === undefined) && <p className="error-msg">Please select Payment Type</p>}
                            </div>
                            <div className="form-group">
                                <NumericTextBox
                                    defaultValue={this.state.amount}
                                    format="c2"
                                    min={0}
                                    value={this.state.amount}
                                    onChange={(e) => this.setState({ amount: e.value })}
                                />
                                {this.state.validation && !this.state.amount && <p className="error-msg">Please enter Amount</p>}
                            </div>
                            <div className="form-group">
                                {this.state.accountId !== 0 &&
                                    <InvoiceDropDown
                                        callbackFromParent={this.myInvoiceCallback}
                                        accountId={this.state.accountId}
                                        className={"form-control"}
                                        value={this.state.invoiceId}
                                    />
                                }
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Description of Charge"
                                    value={this.state.chargeDescription}
                                    onChange={(e) => this.setState({ chargeDescription: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Cheque #, etc"
                                    value={this.state.comment}
                                    onChange={(e) => this.setState({ comment: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    formatPlaceholder="formatPattern"
                                    value={this.state.date}
                                    onChange={(e) => this.setState({ date: e.value })}
                                />
                                {this.state.validation && this.state.date === null && <p className="error-msg">Please enter Date</p>}
                            </div>
                            <LoadingButton className="btn btn-success" onClick={this.save} isLoading={this.state.isSaving}>Add Payment</LoadingButton>
                            {/* Only display the credit card button if they have a publishable key (stripe account) */}
                            {this.state.publishableKey && <React.Fragment>
                                <button className="btn btn-primary" onClick={this.chargeCreditCard} style={{ marginLeft: 10 }}>Credit Card Charge</button>
                            </React.Fragment>}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }

    private setPaymentData(invoice: InvoiceData)
    {
        this.setState({
            accountId: invoice.AccountID,
            invoiceId: invoice.InvoiceId,
            amount: invoice.TotalDue
        });
    }
    private email(){

        if(this.state.isLoading)
        {
            return ;
        }
        this.setState({ isLoading: true });
       fetchApi(`api/billing/email/${this.state.currentPeriodId}`).then(()=>{
        this.setState({ isLoading: false});
           alert("Invoices successfully sent")

       }).catch(()=> {
        this.setState({ isLoading: false});
           alert("Failed to Email invoice batch")
       });

    }
    private handleSourceChange(e: DropDownListChangeEvent) {
        this.setState({ source: e.target.value.value });
    }

    private handleFacilityChange(e: DropDownListChangeEvent) {
        this.setState({ facilityID: e.target.value.ID });
    }

    private myInvoiceCallback = (result: InvoiceSearchResult) => {
        this.setState({
            amount: (result.InvoiceID == -1) ? 0 : result.Amount,
            invoiceId: result.InvoiceID
        });
    };

    public componentDidMount() {
        this.requestBillingPeriods();
        this.requestFacilities();
    }

    private requestBillingPeriods() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        if (data.FacilityID) {
            fetchApi(`api/Billing/GetBillingPeriods`, data, 'POST')
                .then((periods: BillingPeriodData[]) => {
                    this.setState({ periods });
                });
        } else {
            this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }] })
        }

        fetchApi(`api/Stripe/GetPublishableKey`)
            .then((response: string) => { this.setState({ publishableKey: response })});
    }

    private requestFacilities() {
        fetchApi(`api/Facilities/List`)
            .then((facilities: FacilitySearchResult[]) => {
                this.setState({
                    facilities: facilities,
                    facilityID: parseInt(localStorage.getItem("FACILITY_ID") || "0") || undefined
                });
            });
    }

    private requestInvoices() {
        if (this.state.currentPeriodId) {
            this.setState({ isLoading: true });
            fetchApi(`api/Billing/List/${this.state.currentPeriodId}`, {}, 'POST')
                .then((data: { IsGenerated: boolean, ApiInfo: APIInfo, Invoices: InvoiceData[], Errors: AlertData[], Warnings: AlertData[] }) => {
                    this.setState({ isGenerated: data.IsGenerated, invoices: data.Invoices, errors: data.Errors, warnings: data.Warnings, isLoading: false, justImported: false, apiInfo: data.ApiInfo });
                });
        }
    }

    private generate() {
        if (this.state.currentPeriodId) {
            const data = {
                FacilityID: localStorage.getItem("FACILITY_ID")
            }
            if (data.FacilityID) {
                this.setState({ isLoading: true });
                fetchApi(`api/Billing/Generate/${this.state.currentPeriodId}`, data, 'POST')
                    .then(() => {
                        this.setState({ isGenerated: true, isLoading: false });

                        // Reload invoices after finalizing
                        this.requestInvoices();
                    })
                    .catch(() => { alert("Failed to finalize invoices.") });
            } else {
                this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }] })
            }
        }
    }

    private launchQBAuthDialogScreen() {
        this.myWindow = this.openWindow("myWindow", "/QBAuthTokenDialog", .50, .60);
        clearInterval(this.myWindowTimer);
        this.myWindowTimer = setInterval(() => {
            if (!this.myWindow) { //closed manually
                clearInterval(this.myWindowTimer);
            } else if (this.myWindow.closed) { //closed by js
                clearInterval(this.myWindowTimer);
                var processInvoices = this.myWindow.document.getElementById("processInvoices") as HTMLInputElement;
                if (processInvoices.value === "true") { //else just quit silently
                    this.importIntoQB();
                }
            }
        }, 2000);
    }

    private launchQBValidateScreen() {
        this.myWindow = this.openWindow("myWindow", "/QBValidateEntities?BillingPeriodId=" + this.state.currentPeriodId, .70, .70);
        clearInterval(this.myWindowTimer);
        this.myWindowTimer = setInterval(() => {
            if (!this.myWindow) { //closed manually
                clearInterval(this.myWindowTimer);
            } else if (this.myWindow.closed) { //closed by js
                clearInterval(this.myWindowTimer);
                var processInvoices = this.myWindow.document.getElementById("processInvoices") as HTMLInputElement;
                if (processInvoices.value === "true") { //else just quit silently
                    this.importIntoQB();
                }
            }
        }, 2000);
    }

    private importIntoQB() {
        if (this.state.currentPeriodId) {
            this.setState({ isLoading: true, justImported: false, errors: [], warnings: [] });

            const _data = {
                BillingPeriodId: this.state.currentPeriodId
            }

            //"api/Billing/RunQBImport";
            fetchApi(this.state.apiInfo.Links.filter((x: ApiLink) => x.Rel === 'Import')[0].Href, _data, 'POST')
                .then((data: { HasMissingPortalEntities: boolean, TokenExpired: boolean, Errors: AlertData[], Warnings: AlertData[] }) => {
                    this.setState({ errors: data.Errors, warnings: data.Warnings, isLoading: false });
                    if (data.HasMissingPortalEntities) {
                        this.launchQBValidateScreen();
                    } else if (data.TokenExpired) {
                        this.launchQBAuthDialogScreen();
                    } else {
                        this.setState({ justImported: true });
                    }
                }).catch((e) => {
                    this.setState({ errors: [{ Message: 'Import has failed.', Link: '' }], isLoading: false });
                });
        }
    }

    private chargeCreditCard()
    {
        if (this.state.facilityID === -1 || this.state.source === -1 || !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        const data = {
            FacilityID: this.state.facilityID,
            Source: this.state.source,
            Amount: this.state.amount,
            Comment: this.state.comment,
            ChargeDescription: this.state.chargeDescription,
            Date: this.state.date,
            InvoiceId: this.state.invoiceId
        }

        fetchApi(`api/Account/CreateStripeSession/${this.state.accountId}`, data, 'POST')
            .then((response) => {
                console.log(response);
                var stripe = Stripe(this.state.publishableKey)
                stripe.redirectToCheckout({
                    sessionId: response.sessionId
                }).then((result : any) => {
                    console.log(result);
                });
            });
    }

    private openWindow(name: string, url: string, widthpct: number, heightpct: number) {
        //return window.open(url, name, 'toolbar=1, location=1, directories=1, status=1, menubar=1, scrollbars=1, resizable=1, width =' + window.screen.width * widthpct + ', height =' + window.screen.height * heightpct + ',left=' + (window.screen.width - (window.screen.width * widthpct)) / 2 + ',top=' + (window.screen.height - (window.screen.height * heightpct)) / 2 + "'");
        return window.open(url, name, 'toolbar=0, location=0, directories=0, status=0, menubar=0, scrollbars=1, resizable=1, width =' + window.screen.width * widthpct + ', height =' + window.screen.height * heightpct + ',left=' + (window.screen.width - (window.screen.width * widthpct)) / 2 + ',top=' + (window.screen.height - (window.screen.height * heightpct)) / 2 + "'");
    }

    private save() {
        if (this.state.facilityID === -1 || this.state.source === -1 || !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        this.setState({ isSaving: true });

        const data = {
            FacilityID: this.state.facilityID,
            Source: this.state.source,
            Amount: this.state.amount,
            Comment: this.state.comment,
            Date: this.state.date,
            InvoiceId: this.state.invoiceId
        }

        fetchApi(`api/Account/AddPayment/${this.state.accountId}`, data, 'POST')
            .then(() => {
                $("#paymentModal").modal('hide');
                this.setState({ amount: 0, comment: '', validation: false, isSaving: false });
            });
    }
}

export default Invoices;
